import React, { JSX } from 'react'
import { Image } from '../../../../graphql/generated/graphql-types'

export type CardVerticalProps = {
  title?: string
  mainImage: Image
  summary?: string
  footerContent?: JSX.Element
  categoryName?: string
}

export const CardVertical = ({ mainImage, title, summary, footerContent }: CardVerticalProps) => {
  return (
    <div className="card-vertical">
      {mainImage?.url ? (
        <div
          className="card-vertical__image"
          style={{
            backgroundImage: `url(${mainImage.url})`,
          }}></div>
      ) : null}
      <div className="card-vertical__wrap">
        {title ? <h3 className="u-fs-28 card-vertical__title">{title}</h3> : null}
        {summary ? (
          <div
            className="u-fs-16 card-vertical__desctiption"
            dangerouslySetInnerHTML={{ __html: summary }}
          />
        ) : null}
        {footerContent ? (
          <div className="card-vertical__footer">
            <div className="card-vertical__footer-content">{footerContent}</div>
          </div>
        ) : null}
      </div>
    </div>
  )
}
